import StatusLine from "./StatusLine.jsx";
import ReturnForm from "./ReturnForm.jsx";

// Step two: pick the articles and give a reason for each.
export default function OrdersPage({ data }) {
  const { steps, alert, errors, errorHeading } = data;
  return (
    <div id="customers_list" className="customers top-buffer-m" style={{ margin: "0 auto" }}>
      <div className="gr-12">
        <StatusLine steps={steps} active={2} />
      </div>

      {alert && (
        <div className="gr-12">
          <p>
            <span style={{ color: "red", fontSize: "12px" }}>{alert}</span>
          </p>
        </div>
      )}

      {errors?.length > 0 && (
        <div className="gr-12 margin-bottom-s">
          <div className="control-group error">
            <h5>{errorHeading}</h5>
            {errors.map((msg, i) => (
              <label className="parsley-custom-error-message" key={i}>
                {msg}
              </label>
            ))}
          </div>
        </div>
      )}

      <div className="gr-12">
        <ReturnForm data={data} />
      </div>
    </div>
  );
}
